export const PENDING_DETAILS = "PENDING_DETAILS";
export const REGISTERED = "REGISTERED";
export const PROCESSING = "PROCESSING";
export const IN_REVIEW = "IN_REVIEW";
export const VALIDATING = "VALIDATING";
export const FILING_IN_PROGRESS = "FILING_IN_PROGRESS";
export const NOT_STARTED = "NOT_STARTED";
export const FILING_INFO_MISSING = "FILING_INFO_MISSING";

export const MONTHLY = "MONTHLY";
export const QUARTERLY = "QUARTERLY";
export const ANNUALLY = "ANNUALLY";
export const SEMI_ANNUALLY = "SEMI_ANNUALLY";
export const NONE = "NONE";
